/**
 * 不正な日付(文字列型)を判定
 */
export const checkValidDate = (targetDate: string): boolean => {
  return !Number.isNaN(new Date(targetDate.replace(/-/g, "/")).getTime());
};
